import { PlayerEnvironment } from "@javascripts/player_environment"

export default class TickerTape {
  constructor(options = {}) {
    this._tech = options.tech
    this._data = options.data
    this.adState = options.adState
    this._started = false
    this._gptDisplayCalled = false
  }

  get name() {
    return 'ticker_tape'
  }

  get tech() {
    return this._tech
  }

  get data() {
    return this._data
  }

  get started() {
    return this._started
  }

  set started(value) {
    this._started = value
  }

  get gptDisplayCalled() {
    return this._gptDisplayCalled
  }

  set gptDisplayCalled(value) {
    this._gptDisplayCalled = value
  }

  show(options) {
    if(this.started) return
    
    if(this.shouldTriggerTickerTapeAd()) {
      this.started = true
      this.resizePlayer()

      if(this.gptDisplayCalled) {
        window.googletag.cmd.push(this.refreshAd());
      } else {
        window.googletag.cmd.push(this.displayAd());
        this.gptDisplayCalled = true
      }
    }
  }

  hide(shouldResetAdState = true) {
    if(!this.started) return
    
    this.started = false
    this.restorePlayer()

    //TODO: Delete after direct calls to hide in Vidio is removed
    if (shouldResetAdState) {
      this.adState.tryReset(this)
    }
  }

  isReady() {
    return this.shouldTriggerTickerTapeAd()
  }

  //TODO: Delete after calls in Vidio is removed
  start() {
    this.adState.tryShowAd(this)
  }

  shouldTriggerTickerTapeAd() {
    if(!this.gptDefined()) return false
    if(PlayerEnvironment.isMobileSite() && !this.tech.isFullscreen()) return false
    if(PlayerEnvironment.isMobileSite() && this.isPortraitScreen()) return false

    return true
  }

  isPortraitScreen() {
    return screen.height > screen.width;
  }

  refreshAd() {
    return () => {
      window.googletag.pubads().refresh([window.kmklabs.gpt.ticker_tape])
    }
  }

  displayAd() {
    return () => {
      window.googletag.display(window.kmklabs.gpt.ticker_tape)
    }
  }

  gptDefined() {
    return window.googletag?.apiReady && window.kmklabs.gpt?.ticker_tape != null
  }

  resizePlayer() {
    const playerComponentWrapper = document.createElement('div');
    playerComponentWrapper.id = 'player_component_wrapper';
    playerComponentWrapper.className = 'player-component-wrapper';
    
    playerComponentWrapper.append(...this.tech.el().el().childNodes);
    
    this.tech.el().el().append(playerComponentWrapper);
    this.tech.el().el().append(this.createTickerTapeContainer());
    
    window.googletag.pubads().addEventListener('slotOnload', (event) => {
      if(!event.isEmpty && event.slot.getSlotId().getDomId() == 'ticker_tape') {
        playerComponentWrapper.classList.add('ticker-tape');
        
        const tickerTapeContainer = document.getElementById('tickerTapeContainer');
        tickerTapeContainer != null && tickerTapeContainer.classList.add('filled')
      }
    });
  }

  restorePlayer() {
    const playerComponentWrapper = document.getElementById('player_component_wrapper');
    const tickerTapeContainer = document.getElementById('tickerTapeContainer');

    playerComponentWrapper.classList.remove('ticker-tape');
    tickerTapeContainer.classList.remove('filled')

    setTimeout(() => {
      this.tech.el().el().append(...playerComponentWrapper.childNodes);
      playerComponentWrapper.remove();
      tickerTapeContainer.remove()
    }, 1000);
  }

  createTickerTapeContainer() {
    const container = document.createElement('div');
    container.id = 'tickerTapeContainer'
    container.className = 'ticker-tape-container';
    container.innerHTML = `<div id="ticker_tape"></div>`

    return container;
  }
}